import { Component, Input, type OnInit } from '@angular/core'
import { Message } from '../message'

@Component({
  standalone: false,
  selector: 'app-chat-message',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss']
})
export class ChatMessageComponent implements OnInit {
  @Input() message: Message
  className: string = 'message '
  contentText: string
  contentArray: string[]
  dimsFormatted = []
  isAssistant: boolean

  constructor () {}

  // no change

  ngOnInit (): void {
    this.message.timestampFormat = new Date(this.message.timestamp).toLocaleString()
    this.isAssistant = this.message.role == 'assistant'
    this.className += this.isAssistant ? 'message-chatbot' : 'message-user'
    this.contentText = this.message.content
    setTimeout(() => {
      const messages = document.getElementsByClassName('message')
      const messageElement = messages[messages.length - 1]
      messageElement.scrollIntoView({ block: 'end' })
    })
  }
}
